<style lang="scss" scoped>
.uc-profile {
    border: 1px solid #4b8df8;
    margin-bottom: 15px;
    &-title {
        line-height: 40px;
        background-color: #4b8df8;
        color: #fff;
        padding: 0 15px;
    }
    &-content {
        .uc-item {
            border-bottom: 1px solid #ccc;
            padding: 5px 10px;
            margin: 0;
        }
    }
}
</style>


<template>
<div>
	<Bread v-bind="bread"/>
	<div class="uc-profile">
		<h3 class="uc-profile-title">
			<Icon type="ios-person" size='16'></Icon>
			{{$t('port.profile.title')}}
		</h3>
		<Form class="uc-profile-content" ref="form" :label-width='200'>
			<FormItem  :label="$t('port.profile.nick')" class="uc-item">
				<Input v-model="username" v-if="edit"/>
				<span v-else style="line-height:34px;">{{username}}</span>
			</FormItem>
		</Form>
		<div class="text-center">
			<Button class="margin-10" type="primary" @click="edit=!edit" v-if="!edit">{{$t('port.profile.ep')}}</Button>
			<Button class="margin-10"  type="warning" @click="updateInfo" v-else>{{$t('port.profile.submit')}}</Button>
			<Button class="margin-10" type="info" @click="reset">{{$t('port.profile.reset')}}</Button>
		</div>
	</div>
</div>
</template>

<script>
import Bread from '@/components/bread';
import { mapState } from 'vuex';
import { HttpUpdateUserInfo } from "@/service/port";
import { HttpUserInfo } from "@mods/service/base";
export default {
	components: {
		Bread,
	},
	data() {
		return {
			username: '',
			edit: false,
		};
	},
	mounted() {
		this.username = this.userinfo.name;
	},
	computed: {
		...mapState(['userinfo']),
		bread() {
			let data = {};
			switch (this.lang) {
				case 'en':
					data = {
						title: 'My Profile',
						home: 'Main Panel ',
					};
					break;
				default:
					data = {
						title: this.$t('port.profile.title',{defaultValue: "用户资料"}),
						home: this.$t('port.profile.main_panel',{defaultValue: "主面板"}),
					};
					break;
			}
			return data;
		},
	},
	methods: {
		reset() {
			this.username = this.userinfo.name;
			this.edit = false;
		},
		getUserInfo() {
			HttpUserInfo().then(
				res => {
					this.$store.commit('setUserInfo', res.data);
				}
			)
		},
		updateInfo() {
			HttpUpdateUserInfo({ name: this.username, uid: this.userinfo.id }).then(
				res => {
					this.edit = false;
					this.getUserInfo();
					this.$Message.success(res.message);
				},
				err => {
					this.$Message.error(err.message);
				}
			);
		},
	},
};
</script>
